import { GoabText } from '@abgov/angular-components';
import { Component } from '@angular/core';

@Component({
  selector: 'app-account-changes',
  imports: [GoabText],
  templateUrl: './account-changes.html',
  styleUrl: './account-changes.scss',
})
export class AccountChanges {

}
